export default __webpack_public_path__ + "static/car_b.7f3d8ac63e6114c761bb4ac9491c7289.png";